export default __webpack_public_path__ + "static/media/img-stats-graf-03.4e941ea5.jpg";